import { useSelector } from "react-redux";

import { selectMerchants, selectMerchantById } from "./selectors";

import type { RootState } from "../types";

export function useMerchants() {
  const merchants = useSelector(selectMerchants);

  return merchants;
}

export function useMerchant(merchantName: string) {
  const merchant = useSelector((state: RootState) =>
    selectMerchantById(state, merchantName),
  );
  return merchant;
}
